<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">客户姓名</div>
              <div class="itemNum jishi">{{ form.customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">手机号码</div>
              <div class="itemNum">{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">客户编号</div>
              <div class="itemNum">{{ form.customerNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">套餐类型</div>
              <div class="itemNum">{{ form.cardOldIdCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记次数</div>
              <div class="itemNum">{{ form.originNum }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">使用次数</div>
              <div class="itemNum">{{ form.useNum }}</div>
            </div>
          </div>

          <div class="boxs">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>消费记录</i></p>
            <div class="tables">
              <el-table :data="list">
                <el-table-column prop label="消费时间">
                  <template slot-scope="scope">
                    {{formatDate(scope.row.oxCtime)}}
                  </template>
                </el-table-column>
                <el-table-column prop="cardName" label="套餐类型"></el-table-column>
                <el-table-column prop="tradeNum" label="使用次数" width="80"></el-table-column>
                <el-table-column prop="optStaffName" label="收银技师" width="100"></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- <el-table :data="list">
            <el-table-column prop label="签名">
              <template slot-scope="scope">
                <el-image :src="scope.row.imgUrl?scope.row.imgUrl:imgs" :preview-src-list="imgs"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="oxCtime" label="消费时间">
              <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
            </el-table-column>
            <el-table-column prop="cardName" label="套餐类型"></el-table-column>
            <el-table-column prop="tradeNum" label="使用次数"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>-->
        </div>
        <div class="drawer-footer">
          <el-button @click="handleChangeDrawer">返回</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "纸质套餐详情",
      addEditShow: false,
      form: {
        mobile: ""
      },
      columns: [],
      list: [],
      query: {
        cardOldBookId: ""
      },
      url: this.$url.cardOld.pageConsume,
      cardOldName: "",
      showPicker: false,
      imgs: require("../../../assets/images/notImg.png")
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    editInit() {
      this.$on("set", function(org) {
        // Object.assign(this.$data,this.$options.data());
        this.list = [];
        this.query.cardOldBookId = org.id;
        this.getList();
        this.$api.get(this.$url.cardOld.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.form = res;
              this.form.text = this.form.cardOldIdCn;
              this.cardOldName = this.form.cardOldIdCn;
            }
          })
          .catch(error => {});
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
</style>